import { GroupActionTypes, GroupActions } from './types'
import type { IToast } from '@components/molecules/toast'
import type { PaymentIntent, SetupIntent } from '@stripe/stripe-js'


export const setToast = (toast: IToast): GroupActionTypes => ({
    type: GroupActions.SET_TOAST,
    payload: toast
})

export const resetGroupState = (): GroupActionTypes => ({
    type: GroupActions.RESET_GROUP_STATE,
})

export const setRequestBody = (body: CreateGroupRequestBody | undefined): GroupActionTypes => ({
    type: GroupActions.SET_CREATE_REQUEST_BODY,
    payload: body
})
export const updateRequestBody = (body: Partial<CreateGroupRequestBody>): GroupActionTypes => ({
    type: GroupActions.UPDATE_CREATE_REQUEST_BODY,
    payload: body
})

export const setPaymentMethod = (method: CreditCard | ApplePay | GooglePay | undefined): GroupActionTypes => ({
    type: GroupActions.SET_PAYMENT_METHOD,
    payload: method
})
export const addSetupIntent = (intent: SetupIntent): GroupActionTypes => ({
    type: GroupActions.ADD_SETUP_INTENT,
    payload: intent
})
export const addPaymentIntent = (intent: PaymentIntent): GroupActionTypes => ({
    type: GroupActions.ADD_PAYMENT_INTENT,
    payload: intent
})
export const setPledgeAmount = (amount: number | undefined): GroupActionTypes => ({
    type: GroupActions.SET_PLEDGE_AMOUNT,
    payload: amount
})
export const setUseCreditBalance = (useCreditBalance: boolean | undefined): GroupActionTypes => ({
    type: GroupActions.SET_USE_CREDIT_BALANCE,
    payload: useCreditBalance
})


export const setRemovePledge = (pledge: string | undefined): GroupActionTypes => ({
    type: GroupActions.SET_REMOVE_PLEDGE,
    payload: pledge
})


export const setEditingParticipant = (isEditingParticipant: boolean): GroupActionTypes => ({
    type: GroupActions.SET_EDITING_PARTICIPANT,
    payload: isEditingParticipant
})
